import { create } from 'zustand'

type NewIssueDialogStoreT = {
  dialogOpen: boolean
  toggleDialog: () => void
  updateDialogState: (dialogOpen: boolean) => void
  draftIssueId: string | null
  setDraftIssueId: (id: string | null) => void
  addingIssueInProgress: boolean
  setAddingIssueInProgress: (addingIssueInProgress: boolean) => void
}

export const useNewIssueDialogStore = create<NewIssueDialogStoreT>(set => ({
  dialogOpen: false,
  updateDialogState: dialogOpen =>
    set(state => {
      if (dialogOpen) state.setAddingIssueInProgress(true)
      return { dialogOpen }
    }),
  draftIssueId: null,
  setDraftIssueId: draftIssueId => set({ draftIssueId }),
  addingIssueInProgress: false,
  setAddingIssueInProgress: addingIssueInProgress => set({ addingIssueInProgress }),
  toggleDialog: () =>
    set(state => {
      return { dialogOpen: !state.dialogOpen }
    }),
}))
